module.exports = __webpack_public_path__ + "img/znhd.9afad603.jpg";